import { Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18n";

export const UpgradeHint = ({ text, testId = "upgrade-hint" }) => {
  const { t } = useI18n();
  return (
    <div data-testid={testId} className="flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
      <Lock className="w-4 h-4 mt-0.5 shrink-0" />
      <div className="space-y-1">
        <p>{text}</p>
        <Link to="/plans" className="font-semibold underline underline-offset-2" data-testid={`${testId}-link`}>{t("limit.viewPlans")}</Link>
      </div>
    </div>
  );
};
